var map = {
	"./Abyss.png": 71020,
	"./Boulder.png": 53995,
	"./Dark fog.png": 26266,
	"./Flaming wall.png": 82662,
	"./Ford.png": 65641,
	"./Low battery doors.png": 75042,
	"./Magic runes.png": 63098,
	"./Mysterious mist.png": 35609,
	"./Rapids.png": 85295,
	"./Thicket.png": 96128,
	"./Wooden roadblock.png": 95361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47006;